import { cn } from '@/utils'

type InvalidEntryTooltipProps = {
  minPercent: number
  maxPercent: number
}

/** Status bubble under the control after an out-of-range zoom value. */
export function InvalidEntryTooltip({ minPercent, maxPercent }: InvalidEntryTooltipProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'pointer-events-none absolute left-1/2 top-full z-[60] mt-1.5 w-max max-w-[min(260px,calc(100vw-2rem))] -translate-x-1/2',
        'rounded-md bg-primary px-3 py-1.5 text-center text-xs font-normal leading-snug text-primary-foreground shadow-md',
        'animate-in fade-in-0 zoom-in-95 duration-150'
      )}
    >
      Invalid Entry: Allowed values {minPercent}%-{maxPercent}%
    </div>
  )
}
